var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#pattern0_616_1836)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_616_1836",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_616_1836",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_616_1836",
    width: 48,
    height: 48,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAADkUlEQVR4nO1ZS08TURSegLpw6WNhfCyEOygbFirqioWu3Bsf/AB87JW46UYB3QKBe6tNgNxbGESTgoaHCdBEWiMPUR4LNlgpIK8IC9JKwzHn0i4Ifcx0hmFM+iUnmfaeufN9M+eee+aMouSQQw7moWn5BbzxOuHsmSpohyrYJBFsjQj2N25rKqcTOIY+hS3smuJy5SkHjQKv5ywRtEblbE4VDIwZ/UUEqy5sYWdsJ16ovTmpCkoJp1HjxHcb4TRKOG1QOT1hD3kvvU84XTVLfI8QwVYIp3f3jfglSg8TwdxWE1f3WiNey1Lyp3z0KOHsow3kIb4+PuA1rbvztpJnCesr1rQjpgXYFDaQYoE3mCJfxFn5QZFXE+Z138mK/IWm2uNEsOV0k1sFNf1TWM0qxWKez3R37BCg7qTYekPkcXfUs0nZJoDT6HmNntMtQJYHOuLTLgHqzlOo1sfe5crDOsVpAlTO5rBozMgfq0qzmcMUUZEulNylmcNHlsTOFKByWplRgMrpO6cKIJy26xEwoXfC0o5meDDYA6/GgtA6Mw2BxTDMbqynFDC78Uf6oO/L0aA8F+fQLUCw7zpCKHOp/NjfC8NLC7C5tQUD4RDU/RiBJ4F+uNfngxs+b0oBOIY+6IvnDIRDco6vSwvwyN+rR8CyHgFp8//r6XFJ5vnwEJS0eZL6rEcj0hJI/E7mW9LmgRcjQ9LPPfUtwxpgEdMCNmNb8mJVIwEo0ZILMGIlmgeqRwNyTnwaVghIG0J4lxKIxGLgnw9B/cQoVAYHoPxTJ9z0tcKtrna42tEMF71uaXiM/+EY+qAvnuOfD8k5EqCTY+ZDSM8ifujvgS+/5yG2vQ1mEdvehuBiWC5oSxaxkTR6+W0TVAx2Q81oEMTMFHxemJOZJhVwDH3QF8OmYrBbzmFpGnX2RsaeZhSATSfHCmihV/QVc5yGHCeAs5+6u3lYujpQQJUu8kZeaGwTwFmEaA2ndQuQTwHbfU4RIFitYhTFmvtYppd6OwQQwVay7ptir/KgBRRxelsxA+xVmlp8JoxwWqeYhqblE8He2y6As66yftchy5q72HC1TwDttKy5u7vJm31mMhI2ZVbd+WTAXmW22Sl9yNAl0wvWYN+0HjcYC2I9gnke07ZiN3B3lGVHNrUTnsNZleEddl/gcuVh0wn7Nliz44sHvtnFP+BF48fjOIYlsawqnfCZNYcclP8f/wB+Rpkzb4Lv7gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.912800553a518529cfe1bb6e1afa35a3.svg";
export { ForwardRef as ReactComponent };